import React from 'react';
import type { DemographicsReport } from 'bundles/connect/types';
import { Table } from 'react-bootstrap-5';
import { RADII_COLORS } from './demographics_section';
import pluralize from 'pluralize';

type Props = {
  demographicsReport: DemographicsReport;
}

const DEMOGRAPHICS_MAPPING = {
  totalHouseholds: 'Total Households',
  totalPopulation: 'Total Population',
  populationWhite: 'Population White',
  populationBlack: 'Population Black',
  populationHispanic: 'Population Hispanic',
  populationPacificIslander: 'Population Pacific Islander',
  populationAsian: 'Population Asian',
  populationAmericanIndian: 'Population American Indian',
  populationOther: 'Population Other',
  personsPerHousehold: 'Persons Per Household',
  averageHouseholdIncome: 'Average Household Income',
  averageHouseValue: 'Average House Value',
  averageAge: 'Average Age',
  averageAgeMale: 'Average Age Male',
  averageAgeFemale: 'Average Age Female'
};

export default function DemographicsTable({ demographicsReport }: Props) {
  return (
    <div className="table-responsive">
      <Table className="mb-0" striped>
        <thead>
          <tr className="border-bottom border-light">
            <th className="fw-bolder bg-transparent">Radius</th>
            {demographicsReport.radii.map((radius, i) => (
              <th className="bg-transparent" key={i}>
                <div className="d-flex align-items-center justify-content-end gap-1">
                  <span className="fw-bolder text-nowrap">
                    {radius.radiusInMiles} {pluralize('mile', radius.radiusInMiles)}
                  </span>
                  <span
                    className="rounded-5"
                    style={{
                      width: '12px',
                      height: '12px',
                      backgroundColor: RADII_COLORS[i]
                    }}
                  />
                </div>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {Object.keys(DEMOGRAPHICS_MAPPING).map(key => (
            <tr key={key}>
              <td className="border-0">{DEMOGRAPHICS_MAPPING[key]}</td>
              {demographicsReport.radii.map((col, i) => {
                const value = col[key];
                return (
                  <td className="border-0 text-end" key={i}>
                    {value != null ? parseFloat(value).toLocaleString() : '—'}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
}
